import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PerformanceWizardContext from '../PerformanceWizardContext';
import Typography from 'kingpin/atoms/Typography';
import Row from '../../../../../../components/Common/Row';
import Button from 'kingpin/atoms/Button';
import GlowingDiv from '../../../../../../components/TargetManager/GlowingDiv';

const makeFirstCharacterCapital = (s: string) =>
  s[0].toUpperCase() + s.slice(1);

const DatasetNameSuggestion = ({
  fixedIntervalOptions,
}: {
  fixedIntervalOptions: DropdownOption[];
}) => {
  const { wizardState, setWizardState, isReadOnly } = useContext(
    PerformanceWizardContext,
  );

  const intervalText = useMemo(() => {
    const { entity, interval, fixedPeriod } = wizardState.config.datasetStep;
    if (!entity || !interval) {
      return '';
    }

    if (interval === 'fixed' && !!fixedPeriod) {
      const selectedOption = fixedIntervalOptions.find(
        (o) => o.key === fixedPeriod,
      );
      if (!selectedOption) {
        return makeFirstCharacterCapital(fixedPeriod);
      }

      return makeFirstCharacterCapital(
        selectedOption.label.replaceAll(' ', ''),
      );
    } else {
      return makeFirstCharacterCapital(interval);
    }
  }, [fixedIntervalOptions, wizardState.config.datasetStep]);

  const getSuggestedName = useCallback(() => {
    const { entity, interval } = wizardState.config.datasetStep;
    if (!entity || !interval) {
      return undefined;
    }

    const entityText = makeFirstCharacterCapital(entity);
    return `performance${entityText}${intervalText}s`;
  }, [intervalText, wizardState.config.datasetStep]);
  const [suggestedName, setSuggestedName] = useState<string | undefined>(() =>
    getSuggestedName(),
  );
  useEffect(() => {
    setSuggestedName(getSuggestedName());
  }, [getSuggestedName]);

  const onClick = useCallback(() => {
    setWizardState((state) => ({
      ...state,
      config: {
        ...state.config,
        datasetStep: {
          ...state.config.datasetStep,
          name: suggestedName,
        },
      },
    }));
  }, [setWizardState, suggestedName]);

  if (
    isReadOnly ||
    !suggestedName ||
    suggestedName === wizardState.config.datasetStep.name ||
    wizardState.isEditing
  ) {
    return null;
  }

  return (
    <div style={{ marginTop: 4 }}>
      <GlowingDiv glowOnMount>
        <Row centerAlign spaceBetween style={{ padding: 2 }}>
          <Typography.Body type="Body 12">{`Suggested Name: ${suggestedName}`}</Typography.Body>
          <Button onClick={onClick} label={'Apply'} type="Ghost" size="Small" />
        </Row>
      </GlowingDiv>
    </div>
  );
};

export default DatasetNameSuggestion;
